export const WorkspaceFeatureIds = {
  ClarityOutOfBoxReports: 25,
  ClarityCustomReports: 26,
} as const;
